import { useState, useEffect } from "react";

import { KeywordAnalysisData } from "../../../models/KeywordAnalysisData";
import DataSvc from "../../../services/dataSvc";

export const useLatestKeywordAnalysis = (locationId: string) => {
  const [data, setData] = useState<KeywordAnalysisData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!locationId) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await DataSvc.getLatestKeywordAnalysis(locationId);
        setData(result);
        setError(null);
      } catch (err) {
        console.error("Error fetching latest keyword analysis:", err);
        setError(err as Error);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [locationId]);

  return { data, loading, error };
};

export default useLatestKeywordAnalysis;
